import { useCallback as o } from "react";
import { isFunction as i } from "../function/index.js";
function u(r, n) {
  if (r != null) {
    if (i(r)) {
      r(n);
      return;
    }
    try {
      r.current = n;
    } catch {
      throw new Error(`Cannot assign value "${JSON.stringify(n)}" to ref "${r.toString()}"`);
    }
  }
}
function s(...r) {
  return o((n) => {
    r.forEach((t) => {
      u(t, n);
    });
  }, r);
}
export {
  u as assignRef,
  s as useMergeRefs
};
//# sourceMappingURL=useMergeRefs.js.map
